import React, { Component } from 'react';
import './Erreur.js.css';

export class Erreur extends Component {
    render() {
        const { urlLocalisateur } = this.props.serviceGarde;

        return (
            <div className='erreur'>
                <span>
                    Pour obtenir des renseignements, un service de garde doit être identifié au préalable.
                    Veuillez utiliser le lien suivant pour choisir un service de garde : <a href={urlLocalisateur}>cliquez ici</a>
                </span>
            </div>
        );
    }
}
